module.exports = __webpack_public_path__ + "static/vatitude-5f16810d67e4714793a4724c5e24c42f.jpg";